import * as Yup from "yup";

export const fstAssignmentSchema = Yup.object().shape({
  role: Yup.string()
    .oneOf(["user", "broker"], "Select a valid role")
    .required("Role is required"),
  fstUserId: Yup.string().required("Viewer is required"),
  userId: Yup.string().required("User is required"),
});

export const fstAssignmentOtpSchema = Yup.object().shape({
  otp: Yup.string()
    .matches(/^\d{5}$/, "Enter 5-digit OTP")
    .required("OTP is required"),
});
